module.exports = __webpack_public_path__ + "static/media/cup_top_2.4ef612b1.webp";